/* eslint-disable no-console */
/* eslint-disable react/no-unused-prop-types */
import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { useDispatch, useSelector } from 'react-redux';

import { AuthDecorator } from '@components/auth-decorator';
import { actions } from '@state/modals';
import { RootState } from '@state/store';
import { Button } from '@versumstudios/ui';

import * as Styles from './styles';

interface IButtonSave {
  tokenId: string;
}

export const ButtonSave: FC<IButtonSave> = ({ tokenId }) => {
  const t = useTranslations('common');
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const viewer = auth.user?.id;

  const handleClick = () => {
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'token-save', tokenId, viewer } });
  };

  return (
    <Styles.Container>
      <AuthDecorator onClick={handleClick}>
        <Button variant="basic">
          <i>bookmark_border</i>
          {t('save')}
        </Button>
      </AuthDecorator>
    </Styles.Container>
  );
};
